import UI from "./base/UI";
import {scrollTo} from "../functions/simple.ui";

import { isA11yCheckVersion, isA11yKeyPad } from "../functions/a11y.ui";
/**
 * WebNumpad
 */

/**
#### HTML 구조 및 Data 속성 사용법
** [http://172.20.160.28:9700/kbank_html_mmk/components/component_keypad.html](http://172.20.160.28:9700/kbank_html_mmk/components/component_keypad.html)
*/
class WebNumpad extends UI {
    defaults = {};
    amountObserver = {};
    iosKeyDoubleClick = {
		block : false,
		delay : 100,
		repeat : "",
		init : function(me){
			var _super = this;
			var _this = $(me);
			if($('html').hasClass('ios')){
				if(_this.block === true){
					return "ignore";
				}
				_this.block = true;
				_this.repeat = setTimeout(function(){
					_super.block = false;
					clearTimeout(_super.repeat);
				}, _super.delay);
			}

		}
	};
    constructor(el, options) {
        super('webNumpad', el);

        this.init(el, options);
    }
    bindEvent = {
        valueInput: this.valueInput.bind(this),
        quickInput: this.quickInput.bind(this),
        clearValue: this.clearValue.bind(this),
        refreshNumpad: this.refreshNumpad.bind(this),
        hapticOn: this.hapticOn.bind(this),
    }

    init(el, options) {
        this.defaults = {...this.defaults, ...this.parseOptions(options)};
        if (this.defaults.outputTarget != undefined) {
            this.outputType = 'outside'
        }
        this.render();
    }

    update() {
        this.detachEvents();
        this.attachEvents();
    }
    /**
     * ui-webnumpad 속성값, 자식요소에 data-role="" 값 변경시 실행
     * @example 
     * $('.ui-tab').data('ui').render();
     */
    render() {
        this.setProperty();
        this.detachEvents();
        this.attachEvents();
        /*! s: FETASK-a11y page webNumpad 접근성 v.1.0.0 */
        this.isA11yNumpadAcess();
        /*! e: FETASK-a11y page webNumpad Input 접근성 v.1.0.0 */
    }

    setProperty() {
        if (this.$el.find('.keypad-row-output').length) {
            this.$outputWrap = this.$el.find('.keypad-row-output'); //입력값 노출 wrap
            if (this.$outputWrap.find('[data-role="keypad-value"]').length > 1) {
                if (this.$outputWrap.find('[data-role="keypad-value"].readonly').length == 0) {
                    this.$outputWrap.find('[data-role="keypad-value"]').eq(1).addClass('readonly');
                }
                this.$outputInner = this.$outputWrap.find('[data-role="keypad-value"]:not(.readonly)');
            } else {
                this.$outputInner = this.$outputWrap.find('[data-role="keypad-value"]');
            }  
            this.$outputValue = this.$outputInner.find('[data-role="numpad-amount-val"]'); //입력값이 노출 element

            this.$oneTimeLimit = this.$el.find('[data-role="numpad-one-time-limit"]'); //1회 한도 금액
            this.$dayLimit = this.$el.find('[data-role="numpad-day-limit"]'); //1일 한도 금액
            this.$accountBalance = this.$el.find('[data-role="numpad-account-balance"]'); //계좌잔액
            this.$accountLimit = this.$el.find('[data-role="numpad-account-limit"]'); //출금가능 금액
            this.$openbankingLimit = this.$el.find('[data-role="keypad-account-limit"]'); //오픈뱅킹 한도
            this.$nfcChargeLimit = this.$el.find('[data-role="numpad-nfc-charge-limit"]'); //nfc 충전 한도 250212 : CHPFMTASK-1851
            this.$accountLeast = this.$el.find('[data-role="numpad-account-least"]') //최소입력금액   240229 : CHPFMTASK-721
            this.$minLimit = this.$el.find('[data-role="numpad-minimum"]') //최소 금액
            this.$maxLimit = this.$el.find('[data-role="numpad-maximum"]') //최대 금액
            this.$preferCode = this.$el.find('[data-role="numpad-prefer-code"]') //우대코드  240305 : CHPFMTASK-721
            this.$minOverseaLimit = this.$el.find('[data-role="numpad-minimum-oversea"]') //최소 외화금액(외화송금)
            this.$minDomesticLimit = this.$el.find('[data-role="numpad-minimum-domestic"]') //최소 원화금액(외화송금)
            this.$savingAccount = this.$el.find('[data-role="numpad-save-account"]') // 세이빙 잔액  CHPFMTASK-1033 
            this.$minUnit = this.$el.find('[data-role="numpad-minunit"]') //nfc 충전 한도 250401 : CHPFMTASK-1851
            
            this.$subInfo = this.$outputWrap.find('.value-sub-area'); //사용자 현재 정보
            this.$validationArea = this.$outputWrap.find('.validation-area'); //에러 문구
            this.$clearBtn = this.$outputWrap.find('.btn-delete-txt'); //입력된 숫자 전체 삭제
            this.$prevSum = null;   // 이전에 입력된 금액 저장
            this.$validationCount = 0;
            this.$validationStack = [];
            this.$validationTimer;

            const defaultInfo = this.$subInfo.find('.value-s').find('[data-role="default-info-num"]');
            const defaultPreFerInfo = this.$subInfo.find('.value-s.type-prefer').find('[data-role="default-info-num"]');
            const defaultInfo2 = this.$subInfo.find('.value-s').find('[data-role="default-info-num2"]');
            let infoAmount;
            let infoAmount2;

            if (this.defaults.account === 'limit') {
                infoAmount = this.$accountLimit.val();
            } else {
                if (defaultInfo.attr('data-str-info') === 'account') { //최초 노출할 금액종류
                    infoAmount = this.$accountBalance.val();
                } else if (defaultInfo.attr('data-str-info') === 'min') {
                    infoAmount = this.$minLimit.val();
                } else if (defaultInfo.attr('data-str-info') === 'max') {
                    infoAmount = this.$maxLimit.val();
                }
                if (defaultInfo2.attr('data-str-info') === 'min'){
                    infoAmount2 = this.$minLimit.val();
                } else if (defaultInfo2.attr('data-str-info') === 'max') {
                    infoAmount2 = this.$maxLimit.val();
                }
            }

            if (defaultInfo.attr('data-str-type') === 'unit') { //금액 노출 방식(숫자, 단위 포함)
                defaultInfo.text(this.unitSet(Number(infoAmount)));
            } else {
                defaultInfo.text(this.setCommaWithDecimalPoint(Number(infoAmount))+'원');
            }
            if (defaultInfo2.attr('data-str-type') === 'unit') { //금액 노출 방식(숫자, 단위 포함)
                defaultInfo2.text(this.unitSet(Number(infoAmount2)));
            } else {
                defaultInfo2.text(this.setCommaWithDecimalPoint(Number(infoAmount2))+'원');
            }
            if (defaultPreFerInfo.attr('data-str-type') === 'unit') { //금액 노출 방식(숫자, 단위 포함)  //우대코드  240305 : CHPFMTASK-721 
                defaultPreFerInfo.text(this.unitSet(Number(this.$preferCode.val())));
            } 

            if (defaultInfo.prop('tagName') === 'BUTTON') {
                defaultInfo.attr('data-num-str', Number(infoAmount));
            }
            if (defaultInfo2.prop('tagName') === 'BUTTON') {
                defaultInfo2.attr('data-num-str', Number(infoAmount2));
            }
            if (defaultPreFerInfo.prop('tagName') === 'BUTTON') { //우대코드  240305 : CHPFMTASK-721 
                defaultPreFerInfo.attr('data-num-str', Number(this.$preferCode.val()));
            } 
            if (infoAmount < 0) { // 23-01-19 잔액이 마이너스일때 클릭 x
                defaultInfo.attr('disabled','disabled')
                this.$validationArea.find('[data-error-type="balanceOver"] a').addClass('disabled');
            }
            if (this.defaults.account === 'limit') {
                if (this.$validationArea.find('[data-error-type="balanceOver"]').length > 0) {
                    this.$validationArea.find('[data-error-type="balanceOver"]').find('.valied-link').attr('data-num-str', Number(this.$accountLimit.val()));
                    this.$validationArea.find('[data-error-type="balanceOver"]').find('.valied-link').text(this.unitSet(Number(this.$accountLimit.val())));
                }
            } else {
                if (this.$validationArea.find('[data-error-type="balanceOver"]').length > 0) {
                    this.$validationArea.find('[data-error-type="balanceOver"]').find('.valied-link').attr('data-num-str', Number(this.$accountBalance.val()));
                    this.$validationArea.find('[data-error-type="balanceOver"]').find('.valied-link').text(this.unitSet(Number(this.$accountBalance.val())));
                }
            }

            if (this.defaults.errorCheck === 'minMax') { //최소최대금액 에러문구 삽입
                this.$validationArea.find('[data-error-type="minUnder"] .valied-link').text(this.unitSet(Number(this.$minLimit.val())));
                this.$validationArea.find('[data-error-type="maxOver"] .valied-link').text(this.unitSet(Number(this.$maxLimit.val())));
                this.$validationArea.find('[data-error-type="preferMax"] .valied-link').text(this.unitSet(Number(this.$preferCode.val())));  //우대코드  240305 : CHPFMTASK-721
            } else if (this.defaults.errorCheck == 'min') {
                this.$validationArea.find('[data-error-type="minUnder"] .valied-link').text(this.unitSet(Number(this.$minLimit.val())));
            } else if (this.defaults.errorCheck == 'max') {
                this.$validationArea.find('[data-error-type="maxOver"] .valied-link').text(this.unitSet(Number(this.$maxLimit.val())));
            }

            

        } else {
            this.$outputWrap = this.$el;
            this.$outputValue = $(this.defaults.outputTarget);

            if (this.$outputValue.hasClass('ui-text-del')) { //ui-input의 지우기 버튼 사용시 콜백추가
                this.$outputValue.closest('.ui-input').data('ui').beforeDeleteCallback(() => {
                    this.clearValue();
                    this.$outputValue.closest('.ui-input').addClass('active');
                    if (this.inputCallback) {
                        this.inputCallback();
                    }
                });
            }
        }

        if (this.defaults.trn === 'oversea') {
            if (!this.$outputWrap.find('[data-role*="input-value"]').length) {
                this.$outputWrap.prepend('<input type="hidden" data-role="input-value-domestic">') //입력된 값 담아둘 element 생성
                this.$outputWrap.prepend('<input type="hidden" data-role="input-value-oversea">') //입력된 값 담아둘 element 생성
            }
            this.switchInput();
        } else {
            if (!this.$outputWrap.find('[data-role*="input-value"]').length) {
                this.$outputWrap.prepend('<input type="hidden" data-role="input-value">') //입력된 값 담아둘 element 생성
            }
            this.$inputValue = this.$outputWrap.find('[data-role="input-value"]');
            if (this.defaults.type == 'saving') {
                this.$inputValue.val(Number(this.$savingAccount.val()))
            }
            if (this.$inputValue.val() !== undefined && this.$inputValue.val() !== '') {
                this.outputValue(null, 'plus', true);
            }
            // this.setValue('1000000');
        }
        this.$inputWrap = this.$el.find('.keypad-row-input'); //키패드 숫자 영역
        this.$quickInput = this.$inputWrap.find('.keypad-quick'); //키패드 빨리 입력
        this.numberBtn = this.$inputWrap.find('.keypad-table button'); //키패드 숫자 버튼
        // if (this.$el.hasClass('keypad-popup')) { // 240723  위치 변경
        //     this.nextBtn = this.$el.closest('.ui-popup').find('.popup-footer .btn-group').find('a, button').eq(0);
        // } else {
        //     this.nextBtn = this.$el.find('.btn-group').find('a, button').eq(0); //하단 다음 버튼
        // }
        // 0은 빈값 처리
        if (this.$inputValue.val() == '0') {
            this.$inputValue.val('');
        }
        if (this.$inputValue.val() === undefined || this.$inputValue.val() === '' || this.$inputValue.val() === '0') {
            this.btnControl()
        } else {
            this.btnControl('active');
        }

        this.$limitMaximum = this.$el.attr('data-limit-maximum') == 'true' ? true : false;
        this.defaults.limitMaximum = this.$limitMaximum;

        let errorCheck = this.$el.attr('data-error-check');
        if ( this.defaults.errorCheck != errorCheck ) this.defaults.errorCheck = errorCheck;

        // CHPFMTASK-1033  data-numpad-inp 전액 버튼
        if (this.$el.find('[data-full-amount]').length > 0) {
            if (this.$accountBalance.length > 0) {
                if (this.$el.attr('data-direct') == undefined) {
                    this.$el.find('[data-full-amount]').attr('data-numpad-inp', Number(this.$accountBalance.val()))
                } else {
                    if (this.$savingAccount.length > 0 ) {
                        this.$el.find('[data-full-amount]').attr('data-numpad-inp', Number(this.$accountBalance.val()) + Number(this.$savingAccount.val()))
                    }
                }
            }
            
        }
    }
    /**
     * 입력된 숫자 모두 지우기
     * @example 
     * $('.ui-webnumpad').data('ui').clearValue();
     */
    clearValue() {
        this.$inputValue.val('');
        if (this.outputType !== 'outside') {
            this.$subInfo.find('.value-p').text('');
            this.$outputValue.find('span.show').remove();
        }
        if (this.$el.attr('data-code') == 'preferCode') {
            this.$el.addClass('ty01')
            this.$el.removeClass('preferCode')
        }
        this.validationCheck();
    }
    switchInput(){
        if (this.$outputInner.hasClass('oversea')) {
            this.$inputValue = this.$outputWrap.find('[data-role="input-value-oversea"]');
        } else {
            this.$inputValue = this.$outputWrap.find('[data-role="input-value-domestic"]');
        }
    }
    hapticOn(e){
        e.preventDefault();
        this.runHaptic();
    }
    valueInput(e){ //선택한 숫자 포함한 입력값 가공
        //if(this.iosKeyDoubleClick.init(e.currentTarget) == "ignore"){return false} // ios 이중클릭 방지
        e.preventDefault();

        this.runHaptic();
        const clickedBtn = $(e.currentTarget);
        const clickedNum = clickedBtn.attr('data-num-str');
        let prevNum;  // // 240726  data-direct(직접입력) 속성있으면 0 눌리는 조건 추가 이지원님 요청

        if (this.$el.attr('data-direct') != undefined) { // 240726  data-direct(직접입력) 속성있으면 0 눌리는 조건 추가 이지원님 요청
            prevNum = this.$inputValue.val();
        } else {
            prevNum = (this.defaults.type === 'amount' && Number(this.$inputValue.val()) == 0) ? '' : this.$inputValue.val();
        }
        const clickedLength = clickedNum.length;
        let calc = null;
        let whole = null;
        this.$prevSum = prevNum;
        // s: FETASK-557 최대입력 금액 넘으면 입력중지
        const maxLimitNumLength = this.$maxLimit ? String(Number(this.$maxLimit.val())).length : 0;
        if (this.defaults.type == 'amount' && this.$limitMaximum == true && maxLimitNumLength == prevNum.length && clickedNum != 'del') {
            if (this.$outputInner.hasClass('motion')) this.$outputInner.removeClass('motion');
            this.$outputInner.addClass('motion');
            return false;
        }
        // e: FETASK-557 최대입력 금액 넘으면 입력중지

        if (clickedNum !== 'del') { //한칸 지우기 아닌 경우
            const beforeVal = this.$inputValue.val();
            if (clickedBtn.closest('.value-s').length) {
                this.$inputValue.val(Number(clickedNum));
                whole = true;
            } else if (clickedBtn.closest('[data-error-type="balanceOver"]').length > 0) {
                e.preventDefault();
                this.$inputValue.val(Number(clickedNum));
                whole = true;
            }else {
                if (clickedNum ==='dot') {
                    this.$inputValue.val(`${Number(prevNum)}.`);
                } else {
                    // 230130 계좌번호 maxlength 있을시  getvalue 값  maxlength 값 동일
                    if (this.$outputValue.attr('maxlength') != undefined && this.$inputValue.val().length > this.$outputValue.attr('maxlength')) {
                        return false
                    }
                    // 230127 첫자리가 0,00 일때 안눌리는 조건 추가 // 240726  data-direct(직접입력) 속성있으면 0 눌리는 조건 추가 이지원님 요청
                    if ( this.$el.attr('data-direct') == undefined && this.defaults.type !== 'account' && this.$inputValue.val().length === 0 && (clickedNum == '0' || clickedNum == '00')) {
                        return false
                    } else {
                        if (this.defaults.type === 'account') { //240726  data-direct(직접입력) 속성있으면 0 눌리는 조건 추가 이지원님 요청
                            this.$inputValue.val(`${prevNum}${clickedNum}`);
                        } else {
                            let _value = prevNum + clickedNum;
                            this.$inputValue.val(`${Number(_value)}`);
                        }
                    }
                }
            }
            if (typeof this.$el.attr('data-max-length') !== 'undefined') {
                if (this.$inputValue.val().length > this.$el.attr('data-max-length')) {
                    this.$inputValue.val(beforeVal);
                    return;
                }
            }
            calc = 'plus'
            if (this.defaults.trn !== 'oversea') {
                this.$outputValue.next('.btn-delete-txt').off('click.addRemove').on('click.addRemove', (e) => {
                    this.$inputValue.val('');
                    this.validationCheck();
                })
            }
        } else { //한칸 지우기 경우
            if (prevNum.length <= 0) {
                return false;
            }
            this.$inputValue.val(prevNum.substring(0, prevNum.length - 1));
            calc = 'minus'
        }

        this.outputValue(clickedLength, calc, whole);
    }

    quickInput(e) { //빠른 선택 클릭시(+1만, +5만, +10만, +100만)
        e.preventDefault();
        this.runHaptic();
        const realAmount = Number($(e.currentTarget).attr('data-numpad-inp'));
        const prevNum = Number(this.$inputValue.val());
        if ($(e.currentTarget).attr('data-full-amount') == undefined) { // 240827 : 직접입력 전액 버튼 추가 
            this.$inputValue.val(prevNum + realAmount);
        } else {
            this.$inputValue.val(realAmount);
        }
        //this.$inputValue.val(prevNum + realAmount);
        this.outputValue(null, 'plus', true);
    }

    outputValue(clickedLength = null, calc = null, whole = null) { //입력값 노출
        const nowVal = this.$inputValue.val();
        const maxLimitNum = this.$maxLimit && Number(this.$maxLimit.val());
        // 입력금액이 최대금액 초과시
        if (this.defaults.type == 'amount' && this.$limitMaximum == true && nowVal > maxLimitNum) {
            // this.$inputValue.val(this.$prevSum);
            return false;
        }
        // 23-01-18 이체하기 계좌번호 fake_cursor maxlength 계산
        if (this.$outputValue.attr('maxlength') != undefined && nowVal.length >=  Number(this.$outputValue.attr('maxlength'))) {
            return false;
        }

        if (this.outputType == 'outside') { //계좌
            this.$outputValue.val(nowVal);
            if (this.$outputValue.closest('.ui-input').length > 0) {
                this.$outputValue.closest('.ui-input').addClass('active');
                if (this.$outputValue.hasClass('ui-text-del')) {
                    if (nowVal != '') {
                        this.$outputValue.next('.btn-delete-txt').removeClass('hidden')
                    } else {
                        this.$outputValue.next('.btn-delete-txt').addClass('hidden')
                    }
                }
            }
        } else if (this.defaults.trn === 'oversea'){
            this.$outputInner.addClass('active');
            const commaNum =  this.setCommaWithDecimalPoint(nowVal)
            this.$outputValue.text(commaNum);
        } else { //금액
            this.$outputInner.addClass('active');
            this.$subInfo.find('.value-s').find('.ico-bank').hide();
            if (calc === 'plus') { //입력 숫자 더하기
                if (whole !== null) {
                    this.$outputValue.find('span.show').remove();
                    $.each(nowVal.split(''), (i, item) => {
                        this.$outputValue.append(`<span>${item}</span>`);
                    });
                } else {
                    if (Number(nowVal) == 0) {
                        this.$outputValue.find('span.show').eq(0).remove();
                        this.$outputValue.append(`<span>0</span>`);
                    } else {
                        if (this.$outputValue.find('span.show').eq(0).text() == '0') {
                            this.$outputValue.find('span.show').eq(0).remove();
                        }
                        const sliceNum = nowVal.substring(nowVal.length - Number(clickedLength));
                        $.each(sliceNum.split(''), (i, item) => {
                            this.$outputValue.append(`<span>${item}</span>`);
                        });
                    }
                }
            } else { //숫자 빼기
                const nowNum = this.$outputValue.find('span.show:not(.remove)').length;
                this.$outputValue.find('span.show:last').addClass('remove');
                // setTimeout(() => {
                //     this.$outputValue.find('span:last').remove();
                //     this.$outputValue.find('span.remove').remove();
                // }, 200);
                this.$outputValue.find('span:last').remove();
                    this.$outputValue.find('span.remove').remove();
                // const nowNum = this.$outputValue.find('span.show:not(.remove)').length;
                // this.$outputValue.find('span.show').eq(nowNum-1).addClass('remove');
                // setTimeout(() => {
                //     this.$outputValue.find('span.remove').remove();
                // }, 200);
            }
            if (this.defaults.type == 'saving') { // CHPFMTASK-1033
                const savingVal = Number(this.$savingAccount.val());
                const balance = Number(this.$accountBalance.val()); // 연결 계좌 잔액 
                let _nowVal = 0;
                if (nowVal == savingVal) {
                } else if (nowVal >savingVal){
                    _nowVal = nowVal - savingVal;
                } else{
                    _nowVal = savingVal - nowVal;
                }
                if (this.$el.attr('data-direct') != undefined && this.$el.find('[data-role="input-value"]').val() == '0') { // 240731 뺄게요 직접입력인경우에 0 입력시 세이빙계좌만큼 뺄게요 추가
                    if (savingVal == 0) {
                        this.$subInfo.find('.value-p').text('');
                    } else {
                        this.$subInfo.find('.value-p').text(this.unitSet(_nowVal));
                    }
                    
                }
                if (savingVal < balance) {
                    if (_nowVal>balance) {
                        this.$subInfo.attr('over-saving', true)
                    } else {
                        this.$subInfo.attr('over-saving', false)
                    }
                    if (_nowVal != 0) {
                        if (this.$subInfo.attr('over-saving') == 'false') {
                            this.$subInfo.find('.value-p').text(this.unitSet(_nowVal));
                        } else {
                            this.$subInfo.find('.value-p').text('');
                        }
                    }
                } else {
                    if (nowVal>(balance +savingVal)) {
                        this.$subInfo.attr('over-balance', true)
                    } else {
                        this.$subInfo.attr('over-balance', false)
                    }
                    if (nowVal != 0) {
                        if (this.$subInfo.attr('over-balance') == 'false') {
                            this.$subInfo.find('.value-p').text(this.unitSet(_nowVal));
                        } else {
                            if (nowVal < savingVal) {
                                this.$subInfo.find('.value-p').text(this.unitSet(_nowVal));
                            } else {
                                this.$subInfo.find('.value-p').text('');
                            }
                        }
                    }
                }
            } else {
                this.$subInfo.find('.value-p').text(this.unitSet(nowVal));
            }
            this.$outputValue.find('span:not(.show)').addClass('show');
        }
        if (this.inputCallback) {
            this.inputCallback();
        }
        this.validationCheck();
    }

    stackValidation(args){
        var that = this;

        if(this.$validationStack.length){
            this.$validationStack.push(this.$validationCount);
            return false;
        }

        [...args].forEach(function(arg){
            if (typeof arg === 'boolean' && arg === true) {
                that.$validationCount = 1;
                that.$validationStack.push(arg);
            }
        }); 
        return true;
    }

    clearValidationStack(){
        while(this.$validationStack.length){
            this.$validationStack.pop();
            this.$validationStack.length && this.$validationCount--;
        }
    }

    validationCheck() { //한도체크, 버튼 활성화
        if (this.outputType !== 'outside') {
            const nowVal = Number(this.$inputValue.val()); //현재 입력값
            const dayLimiVal = Number(this.$dayLimit.val()); //1일 한도  (하루에 보낼 수 있는)
            const oneTimeLimitVal = Number(this.$oneTimeLimit.val()); //1회 한도 (한 번에 보낼 수 있는)
            const accountBalanceVal = Number(this.$accountBalance.val()); //계좌잔액
            const openbankingLimitVal = Number(this.$openbankingLimit.val()); //오픈뱅킹 제한
            const nfcChargeLimitVal = Number(this.$nfcChargeLimit.val()); //nfc 충전 한도 250212 : CHPFMTASK-1851
            const accountLimitVal = Number(this.$accountLimit.val()); //출금가능금액
            const maxEl = this.$el.find('[data-role="numpad-maximum"]');
            const minUnit = this.$el.find('[data-role="numpad-minunit"]') //nfc 충전 한도 250401 : CHPFMTASK-1851
            const nowLastVal = Number(nowVal % 10); //nfc 충전 한도 250401 : CHPFMTASK-1851

            if (this.defaults.trn === 'oversea') {
                this.overseaError();
            } else {
                //nfc 충전 한도 250401 : CHPFMTASK-1851
                if (minUnit.length > 0) {
                    console.log('nowLastVal',nowLastVal)
                    if(nowLastVal != '0'){
                        this.minUnitError()
                    } else {
                        this.minUnitError('hide');
                    }
                }
                if (this.defaults.errorCheck === 'minMax') {
                    const accountLeast = Number(this.$accountLeast.val()); //최소입력금액   240229 : CHPFMTASK-721
                    const minLimiteVal = Number(this.$minLimit.val()); //최소가입액
                    const maxLimitVal = Number(this.$maxLimit.val()); //최대가입액 제한
                    const preferCode = Number(this.$preferCode.val()); //우대코드  240305 : CHPFMTASK-721
                    if (this.$inputValue.val() !== '') {
                        if (this.$accountBalance.length > 0) { //계좌잔액 체크시
                            if (nowVal < minLimiteVal ||
                                nowVal > maxLimitVal ||
                                nowVal > accountBalanceVal
                            ) {
                                if (nowVal < minLimiteVal) {
                                    this.minimumError()
                                } else {
                                    if (!maxEl.length && nowVal > accountBalanceVal) {    // 20230327 입력금액이 잔고보다 큰 경우 
                                        this.balanceOverError();
                                    }else if(maxLimitVal > accountBalanceVal && nowVal > accountBalanceVal) {  // 20230327 입력금액과 최대금액이 잔고보다 큰 경우
                                        this.balanceOverError();
                                    }else {
                                        this.maximumError();
                                    }
                                }
                                const _that = this;
                                setTimeout(function(){
                                    _that.btnControl();
                                }, 50);
                            } else {
                                this.balanceOverError('hide');
                                this.minimumError('hide');
                                this.maximumError('hide');
                                this.btnControl('active');
                            }
                        } else {

                            if (accountLeast > 0) {
                                if (nowVal < minLimiteVal ||
                                    nowVal > maxLimitVal
                                ) {
                                    if (nowVal < minLimiteVal && nowVal < accountLeast) {
                                        this.minimumError()
                                    } else if (nowVal < minLimiteVal && nowVal > accountLeast) {
                                        this.minMaxError()
                                        if (this.$el.hasClass('preferCode')) {
                                            this.$el.addClass('ty01')
                                            this.$el.removeClass('preferCode')
                                        }
                                    } else {
                                        this.maximumError();
                                    }
                                    const _that = this;
                                    setTimeout(function(){
                                        _that.btnControl();
                                    }, 50);
                                } else {
                                    if ( preferCode > 0) { // 우대코드  240305 : CHPFMTASK-721
                                        if (nowVal >  preferCode) {
                                            this.preferMaxError();
                                            const _that = this;
                                            setTimeout(function(){
                                                _that.btnControl();
                                            }, 50);
                                        } else {
                                            this.$el.removeClass('ty01')
                                            this.$el.addClass('preferCode')
                                            this.minimumError('hide');
                                            this.maximumError('hide');
                                            this.minMaxError('hide')
                                            this.btnControl('active');
                                        }
                                    } else {
                                        this.minimumError('hide');
                                        this.maximumError('hide');
                                        this.minMaxError('hide')
                                        this.btnControl('active');
                                    }
                                    
                                }
                            } else {
                                if (nowVal < minLimiteVal ||
                                    nowVal > maxLimitVal
                                ) {
                                    if (nowVal < minLimiteVal) {
                                        this.minimumError()
                                    } else {
                                        this.maximumError();
                                    }
                                    const _that = this;
                                    setTimeout(function(){
                                        _that.btnControl();
                                    }, 50);
                                } else {
                                    this.minimumError('hide');
                                    this.maximumError('hide');
                                    this.btnControl('active');
                                }
                            }
                            
                        }
                    }
                } else if (this.defaults.errorCheck == 'min'){
                    const minLimiteVal = Number(this.$minLimit.val()); //최소가입액

                    if (this.$inputValue.val() !== '') {
                        if (this.$accountBalance.length > 0) { //계좌잔액 체크시
                            if (nowVal < minLimiteVal ||
                                nowVal > accountBalanceVal
                            ) {
                                if (nowVal < minLimiteVal) {
                                    this.minimumError()
                                } else if (nowVal > accountBalanceVal) {
                                    this.balanceOverError();
                                }
                                const _that = this;
                                setTimeout(function(){
                                    _that.btnControl();
                                }, 50);
                            } else {
                                this.balanceOverError('hide');
                                this.minimumError('hide');
                                this.maximumError('hide');
                                this.btnControl('active');
                            }
                        } else {
                            if (nowVal < minLimiteVal) {
                                this.minimumError()
                                const _that = this;
                                setTimeout(function(){
                                    _that.btnControl();
                                }, 50);
                            } else {
                                this.minimumError('hide');
                                this.maximumError('hide');
                                this.btnControl('active');
                            }
                        }
                    }
                } else if (this.defaults.errorCheck == 'max') {
                    const maxLimitVal = Number(this.$maxLimit.val()); //최대가입액 제한
                    if (this.$inputValue.val() !== '') {
                        if (this.$accountBalance.length > 0) { //계좌잔액 체크시
                            if (nowVal > maxLimitVal ||
                                nowVal > accountBalanceVal
                            ) {
                                if (nowVal > accountBalanceVal) {
                                    this.balanceOverError();
                                } else {
                                    this.maximumError();
                                }
                                const _that = this;
                                setTimeout(function(){
                                    _that.btnControl();
                                }, 50);
                            } else {
                                this.balanceOverError('hide');
                                this.minimumError('hide');
                                this.maximumError('hide');
                                this.btnControl('active');
                            }
                        } else {
                            if (nowVal > maxLimitVal) {
                                this.maximumError();
                                const _that = this;
                                setTimeout(function(){
                                    _that.btnControl();
                                }, 50);
                            } else {
                                this.minimumError('hide');
                                this.maximumError('hide');
                                this.btnControl('active');
                            }
                        }
                    }
                } else if (this.defaults.type == 'saving') { // CHPFMTASK-1033
                    const savingVal = Number(this.$savingAccount.val()); // 세이빙 잔액 
                    const balance = Number(this.$accountBalance.val()); // 연결 계좌 잔액 
                    let _savingValue;

                    if (nowVal == savingVal || nowVal == 0) {
                        if (this.$el.attr('data-direct') != undefined && this.$el.find('[data-role="input-value"]').val() == '0' && savingVal != 0) {
                            this.$subInfo.attr('data-saving','minus')
                            _savingValue = 'minus'
                        }else {
                            this.$subInfo.attr('data-saving','etc')
                            _savingValue = 'etc'
                        }
                        // this.$subInfo.attr('data-saving','etc')
                        // _savingValue = 'etc'
                    } else if (nowVal > savingVal) {
                        this.$subInfo.attr('data-saving','plus')
                        _savingValue = 'plus'
                    }  else {
                        this.$subInfo.attr('data-saving','minus')
                        _savingValue = 'minus'
                    }
                    if(balance < savingVal) {

                    }
                    if (_savingValue == 'plus') {
                        if (this.$subInfo.attr('over-saving') == 'true' || this.$subInfo.attr('over-balance') == 'true') {
                            this.$subInfo.find('.value-s').text('');
                            if (nowVal < (savingVal + balance)) {
                                this.$subInfo.find('.value-s').text('을 더할게요');
                                this.btnControl('active')
                            } else {
                                this.$subInfo.find('.value-s').append(`<div class="over-saving-text">연결계좌의 <button type="button" data-role="default-info-num" data-str-info="account" data-str-type="num" data-num-str="${balance+savingVal}">잔액</button>만큼만 더할 수 있어요.</div>`);
                                this.$subInfo.find('.over-saving-text button').off(`click${this.eventId}`).on(`click${this.eventId}`, this.bindEvent.valueInput);
                                this.btnControl('error');
                            }
                        } else {
                            if (this.$subInfo.attr('over-balance') == 'etc') {
                                this.$subInfo.find('.value-s').text('');
                                this.btnControl('active')
                            } else {
                                this.$subInfo.find('.value-s').text('을 더할게요');
                                this.btnControl('active')
                            }
                        }
                    }  else if (_savingValue == 'minus') {
                        if (savingVal != 0 ) {
                            this.$subInfo.find('.value-s').text('을 뺄게요');
                        }
                        
                        this.btnControl('active')
                    } else {
                        this.btnControl()
                    }
                } else {
                    if (this.defaults.account === 'limit') {  // 출금가능금액
                        if (nowVal > dayLimiVal ||
                            nowVal > oneTimeLimitVal ||
                            nowVal > openbankingLimitVal ||
                            nowVal > nfcChargeLimitVal || //nfc 충전 한도 250212 : CHPFMTASK-1851
                            nowVal > accountLimitVal
                        ) {
                            if (nowVal > dayLimiVal) {
                                this.dayLimitError()
                            } else if (nowVal > oneTimeLimitVal > 0) {
                                this.oneTimeLimitError()
                            } else if (nowVal > accountLimitVal > 0) {
                                this.balanceOverError()
                            } else if (nowVal > openbankingLimitVal > 0) {
                                this.openbankingLimit()
                            } else if (nowVal > nfcChargeLimitVal > 0) { //nfc 충전 한도 250212 : CHPFMTASK-1851
                                this.nfcChargeLimit()
                            } else if (accountLimitVal < nfcChargeLimitVal > 0) { //nfc 충전 한도 250212 : CHPFMTASK-1851
                                this.balanceOverError()
                            }
    
                            const _that = this;
                            setTimeout(function(){
                                _that.btnControl();
                            }, 50);
                        } else {
                            this.oneTimeLimitError('hide');
                            this.dayLimitError('hide');
                            this.balanceOverError('hide');
                            this.openbankingLimit('hide');
                            this.nfcChargeLimit('hide'); //nfc 충전 한도 250212 : CHPFMTASK-1851
                            this.btnControl('active');
                        }
                    } else { // 잔액 (밸런스)
                        if (nowVal > dayLimiVal ||
                            nowVal > oneTimeLimitVal ||
                            nowVal > accountBalanceVal ||
                            nowVal > openbankingLimitVal ||
                            nowVal > nfcChargeLimitVal //nfc 충전 한도 250212 : CHPFMTASK-1851
                        ) {
                            if (nowVal > dayLimiVal) {
                                this.dayLimitError()
                            } else if (nowVal > oneTimeLimitVal > 0) {
                                this.oneTimeLimitError()
                            } else if (nowVal > accountBalanceVal > 0) {
                                //nfc 충전 한도 250212 : CHPFMTASK-1851
                                if(nfcChargeLimitVal != NaN && accountBalanceVal > nfcChargeLimitVal > 0){
                                    this.nfcChargeLimit()
                                } else {
                                    this.balanceOverError()
                                }
                                // this.balanceOverError()
                            } else if (nowVal > openbankingLimitVal > 0) {
                                this.openbankingLimit()
                            } else if (nowVal > nfcChargeLimitVal > 0) { //nfc 충전 한도 250212 : CHPFMTASK-1851
                                this.nfcChargeLimit()
                            } 
                            const _that = this;
                            setTimeout(function(){
                                _that.btnControl();
                            }, 50);
                        } else {
                            this.oneTimeLimitError('hide');
                            this.dayLimitError('hide');
                            this.balanceOverError('hide');
                            this.openbankingLimit('hide');
                            this.nfcChargeLimit('hide'); //nfc 충전 한도 250212 : CHPFMTASK-1851
                            this.btnControl('active');
                        }
                    }
                }
            }
            if (this.$inputValue.val() === '') {
                this.$outputInner.removeClass('active error');
                this.$subInfo.find('.value-s').find('.ico-bank').show();
            }

            if (!this.$outputInner.hasClass('error')) {
                if (this.$inputValue.val() == 0) {
                    
                    if (this.$el.attr('data-direct') == undefined) {
                        this.btnControl();
                    } else {
                        if(this.$inputValue.val() == '') {
                            this.btnControl();
                            
                        } else {
                            this.btnControl('active');
                        }
                        
                    }
                    
                }
            }
        } else {
            if (this.$inputValue.val() == 0) {
                this.btnControl();
            } else {
                this.btnControl('active');
            }
        }
    }

    btnControl(flag = null) {
        const devCtaCheck = this.$el.find('[data-role="numpad-cta-enable"]');
        if (this.$el.hasClass('keypad-popup')) {  // 240723  위치 변경
            this.nextBtn = this.$el.closest('.ui-popup').find('.popup-footer .btn-group').find('a, button').eq(0);
        } else {
            this.nextBtn = this.$el.find('.btn-group').find('a, button').eq(0); //하단 다음 버튼
        }
        if (flag == 'active') {
            if (devCtaCheck.length > 0 && devCtaCheck.val().toUpperCase() !== 'Y') {
                this.nextBtn.addClass('disabled');
                this.nextBtn.attr('disabled', true);
            } else {
                if (this.$el.attr('data-direct') == undefined) { // CHPFMTASK-1297
                    this.nextBtn.removeClass('disabled');
                    this.nextBtn.attr('disabled', false);
                } else { // CHPFMTASK-1297
                    if (this.$savingAccount.length > 0 &&  this.$inputValue.length > 0 &&  Number(this.$savingAccount.val()) == Number(this.$inputValue.val())) {
                        this.nextBtn.addClass('disabled');
                        this.nextBtn.attr('disabled', true);
                    } else {
                        this.nextBtn.removeClass('disabled');
                        this.nextBtn.attr('disabled', false);
                    }
                }
                // this.nextBtn.removeClass('disabled');
                // this.nextBtn.attr('disabled', false);
            }
        } else {
            this.nextBtn.addClass('disabled');
            this.nextBtn.attr('disabled', true);
        }
        // if (this.$el.attr('data-direct') != undefined && devCtaCheck.length == 0) {  // 240726  data-direct(직접입력) 속성있으면 0 눌리는 조건 추가 이지원님 요청
        //     this.nextBtn.removeClass('disabled');
        //     this.nextBtn.attr('disabled', false);
        // } 
    }

    setCommaWithDecimalPoint(val){
        try {
            var parts = Number(val).toString().split(".");
            return parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",") + (parts[1] || parts.length === 2 ? "." + parts[1] : "");
        } catch (error) {
            return val
        }
    }

    unitSet(num) { //숫자 한글단위 추가를 위한 분리 // 20230130 조, 경 단위 추가 및 작동방식 변경
        const _this = this;
        const tempVal = num.toString().replace(/\B(?=(\d{4})+(?!\d))/g, ",");
        const tempArr = tempVal.split(',').reverse();
        
        const unitArr = ["", "만", "억", "조", "경"];
        const maxUnitString = unitArr.length;
        let unitText = tempArr.map((v, i) => {
            if (i < maxUnitString && Number(v) > 0) return `${_this.setCommaWithDecimalPoint(v)}${unitArr[i]}`;
        }).reverse().join(' ').trim();
        return (unitText ? unitText : "0") + "원";
    }


    overseaError() {
        if (this.$outputInner.hasClass('domestic')) { //원화 입력 중 error 체크
        } else { //외화 입력 중 error 체크
        }
    }

    dayLimitError(flag = 'show'){ //1일 이체 초과
        const errorFlag = 'dayLimit'
        if (flag == 'show') {
            this.errorShow(errorFlag);
        } else {
            this.errorHide(errorFlag)
        }
    }

    oneTimeLimitError(flag = 'show'){ //1회 이체 초과
        const errorFlag = 'oneTimeLimit'
        if (flag == 'show') {
            this.errorShow(errorFlag);
        } else {
            this.errorHide(errorFlag)
        }
    }

    balanceOverError(flag = 'show'){ //계좌잔액초과
        const errorFlag = 'balanceOver'
        if (flag == 'show') {
            this.errorShow(errorFlag);
        } else {
            this.errorHide(errorFlag)
        }
    }

    openbankingLimit(flag = 'show'){ //오픈뱅킹한도초과
        const errorFlag = 'openbankingLimit'
        if (flag == 'show') {
            this.errorShow(errorFlag);
        } else {
            this.errorHide(errorFlag)
        }
    }

    nfcChargeLimit(flag = 'show'){ //nfc 충전 한도 250212 : CHPFMTASK-1851
        const errorFlag = 'nfcChargeLimit'
        if (flag == 'show') {
            this.errorShow(errorFlag);
        } else {
            this.errorHide(errorFlag)
        }
    }

    minUnitError(flag = 'show'){ //nfc 충전 한도 250401 : CHPFMTASK-1851
        const errorFlag = 'minUnit'
        if (flag == 'show') {
            this.errorShow(errorFlag);
        } else {
            this.errorHide(errorFlag)
        }
    }

    minimumError(flag = 'show'){ //최소입력 미만
        const errorFlag = 'minUnder'
        if (flag == 'show') {
            this.errorShow(errorFlag);
        } else {
            this.errorHide(errorFlag);
        }
    }
    minMaxError(flag = 'show'){ //최소입력 미만 // 240229 : CHPFMTASK-721
        const errorFlag = 'minMaxHold'
        if (flag == 'show') {
            this.errorShow(errorFlag);
        } else {
            this.errorHide(errorFlag);
        }
    }

    maximumError(flag = 'show'){ //최대입력 초과
        if (this.$maxLimit.val() === 'null') {return false;}
        const errorFlag = 'maxOver'
        if (flag == 'show') {
            this.errorShow(errorFlag);
        } else {
            this.errorHide(errorFlag)
        }
    }
    preferMaxError(flag = 'show'){ //우대코드  240305 : CHPFMTASK-721
        if (this.$preferCode.val() === 'null') {return false;}
        const errorFlag = 'preferMax'
        if (flag == 'show') {
            this.errorShow(errorFlag);
        } else {
            this.errorHide(errorFlag)
        }
    }

    runHaptic(){
        if(typeof MobileCallUtils !== 'undefined'){ 
            try {
                //MobileCallUtils.etc.callDeviceHaptic('', 'oneShot', 1); //20221219 햅틱 분기 삭제

                //230504 : 안드로이드 햅틱 이슈
                if ($('html').hasClass('ios')) { // 아이폰
                    MobileCallUtils.etc.callDeviceHaptic('', 'oneShot', 0); // CHPFMTASK-687 : 240216 : 1 -> 0 수정  
                } else { // 안드로이드
                    //MobileCallUtils.etc.callDeviceHaptic('', 'oneShot', 50);
                }
            } catch (error) {
            }
        }
    }
 
    // /**
    //  * 에러 active
    //  * @param errorType    {string}  보여줄 에러 메시지 [data-error-type] 속성값, 빈 값일 경우 에러 메시지 노출 없이 에러 상태만 표현
    //  */
    errorShow(errorType = null){
        if (!this.$outputInner.hasClass('error')) {
            this.$outputInner.addClass('error');
        }
        if (!this.$outputInner.hasClass('motion')) {
            this.$outputInner.addClass('motion');
            setTimeout(() => {
                this.$outputInner.removeClass('motion');
            }, 1050)
        }
        if (errorType !== null) {
            this.$outputInner.find('.validation-txt-set').removeClass('show');
            this.$outputInner.find(`[data-error-type="${errorType}"]`).addClass('show');
        }
        if (errorType == 'minMaxHold') { // 240229 : CHPFMTASK-721
            if (!this.$outputInner.hasClass('hold')) {
                this.$outputInner.addClass('hold');
            }
        }
    }

    // /**
    //  * 에러 deactive
    //  * @param errorType    {string}  숨길 에러 메시지 [data-error-type] 속성값
    //  */
    errorHide(errorType = null){
        if (errorType !== null) {
            this.$outputInner.find(`[data-error-type="${errorType}"]`).removeClass('show');
        }
        if (!this.$outputInner.find('.validation-txt-set.show').length) {
            this.$outputInner.removeClass('error');
        }
        if (errorType == 'minMaxHold') { // 240229 : CHPFMTASK-721
            this.$outputInner.removeClass('error hold');
        }
    }

    attachEvents() {
        let eventName, that = this;
        if ($('html').hasClass('pc')) {
            eventName = 'click'
        } else {
            // eventName = $('html').hasClass('pc_m') ? 'mousedown' : 'touchstart';  // 240228 :  CHPFMTASK-687 : 햅틱관련 touchend -> touchstart 변경

            // if(isA11yCheckVersion()){240228 :  CHPFMTASK-687 : 접근성 조건문 제외 
                
            // }
            const isIOS = (/iPad|iPhone|iPod/.test(navigator.userAgent || navigator.vendor || window.opera) && !window.MSStream);
                
            if(isIOS){
                eventName = $('html').hasClass('pc_m') ? 'mousedown' : 'touchstart';  // 240228 :  CHPFMTASK-687 : 햅틱관련 touchend -> touchstart 변경
            }else{
                //모바일 스크린리더 안드로이드 대응 클릭이벤트로 변경
                eventName = $('html').hasClass('pc_m') ? 'mousedown' : 'click';
            }
        }

        // if (this.defaults.type == 'account') {
        //     this.numberBtn.on(`${eventName}${this.eventId}`, this.bindEvent.valueInput);
        // } else {
            
        // }


        this.numberBtn.off(`${eventName}${this.eventId}`).on(`${eventName}${this.eventId}`, this.bindEvent.valueInput);
        this.$quickInput.find('[data-numpad-inp]').off(`click${this.eventId}`).on(`click${this.eventId}`, this.bindEvent.quickInput);
        if (this.outputType !== 'outside') {
            this.$subInfo.find('.value-s button').off(`click${this.eventId}`).on(`click${this.eventId}`, this.bindEvent.valueInput);
            if (this.$outputInner.find('[data-error-type="balanceOver"]').length > 0) {
                if (this.$outputInner.find('[data-error-type="balanceOver"]').find('.valied-link').attr('data-num-str') > 0) { // 23-01-19 잔액이 마이너스일때 클릭 x
                    this.$outputInner.find('[data-error-type="balanceOver"]').find('.valied-link').on(`click${this.eventId}`, this.bindEvent.valueInput);
                }
                
            }
        }
        if (this.$clearBtn != undefined) {
            this.$clearBtn.on(`click${this.eventId}`, this.bindEvent.clearValue);
        }
        if (this.defaults.trn === 'oversea') {
            this.$el.find('.btn-trn-txt').off(`click${this.eventId}`).on(`click${this.eventId}`, (e) => {
                if (this.$outputWrap.find('[data-role="keypad-value"].active').length) {
                    return false;
                } else {
                    if ($(e.currentTarget).closest('[data-role="keypad-value"]').hasClass('readonly')) {
                        $(e.currentTarget).closest('[data-role="keypad-value"]').removeClass('readonly');
                        $(e.currentTarget).closest('[data-role="keypad-value"]').siblings('[data-role="keypad-value"]').addClass('readonly');
                        this.$outputInner = $(e.currentTarget).closest('[data-role="keypad-value"]');
                        this.$outputValue = this.$outputInner.find('[data-role="numpad-amount-val"]'); //입력값이 노출 element
                        this.switchInput();
                    }
                }
            });
        }

        if (this.defaults.type == 'amount') {
            // s: 20230220 동적 설정값 변경시 사용
            this.amountObserver = new MutationObserver(mutations => {
                that.refreshNumpad();
            });
            
            this.amountObserver.observe(this.$el[0], {attributes: true});

            const maxEl = this.$el.find('[data-role="numpad-maximum"]');
            if (maxEl.length > 0) {
                this.amountObserver.observe(maxEl[0], {attributes: true});
            }
            const minEl = this.$el.find('[data-role="numpad-minimum"]');
            if (minEl.length > 0) {
                this.amountObserver.observe(minEl[0], {attributes: true});
            }
            const balanceEl = this.$el.find('[data-role="numpad-account-balance"]');
            if (balanceEl.length > 0) {
                this.amountObserver.observe(balanceEl[0], {attributes: true});
            }
            //nfc 충전 한도 250401 : CHPFMTASK-1851
            const minUnitEl = this.$el.find('[data-role="numpad-minunit"]');
            if (minUnitEl.length > 0) {
                console.log('minUnitEl',minUnitEl)
                this.amountObserver.observe(minUnitEl[0], {attributes: true});
            }
            // e: 20230220 동적 설정값 변경시 사용

            // s: 20230227 오류금액 클릭시 바로 설정
            this.$el.on('click', '.valied-link', (e) => {
                e.preventDefault();
                const type =  this.$el.find('.show[data-error-type]').data('errorType');
                const root = this.$el;
                let val = root.find('[data-role="input-value"]').val();
                if(type == 'minUnder') {
                   val = root.find('[data-role="numpad-minimum"]').val();
                } else if (type == 'maxOver') {
                    val = root.find('[data-role="numpad-maximum"]').val();
                } else if (type == 'balanceOver') {
                    if (this.defaults.account === 'limit') {
                        val = root.find('[data-role="numpad-account-limit"]').val();
                    } else {
                        val = root.find('[data-role="numpad-account-balance"]').val();
                    }
                } else if (type == 'minMaxHold') { // 240229 : CHPFMTASK-721
                    val = root.find('[data-role="numpad-minimum"]').val();
                } else if (type == 'preferMax') {
                    val = root.find('[data-role="numpad-prefer-code"]').val();
                } else if (type == 'nfcChargeLimit') { //nfc 충전 한도 250212 : CHPFMTASK-1851
                    val = root.find('[data-role="numpad-nfc-charge-limit"]').val();
                }
                root.data('ui').setValue(val * 1);
            });
            // e: 20230227 오류금액 클릭시 바로 설정
        }

    }

    detachEvents() {
        //this.numberBtn.off(this.eventId);
        this.$quickInput.find('[data-numpad-inp]').off(this.eventId);
        if (this.outputType !== 'outside') {
            this.$subInfo.find('.value-s button').off(this.eventId);
            if (this.$outputInner.find('[data-error-type="balanceOver"]').length > 0) {
                this.$outputInner.find('[data-error-type="balanceOver"]').find('.valied-link').off(this.eventId);
            }
        }
        // if (this.$clearBtn !== undefined) {
        //     this.$clearBtn.off(this.eventId);
        // }
        if (this.defaults.trn === 'oversea') {
            this.$el.find('.btn-trn-txt').off(this.eventId);
        }
        if (this.amountObserver?.disconnect) {
            this.amountObserver.disconnect();
            this.amountObserver = {};
        }
    }

    /**
     * 키패드 입력시 실행할 함수
     * @param callback    {function}  입력 후 실행될 함수
     * @example 
     * $('.ui-webnumpad').data('ui').numInputCallback(function(){});
     */
    numInputCallback(callback) {
        if ($.isFunction(callback)) {
            this.inputCallback = callback;
        }
    }
    bottomOpen(scrollMotion = false){ // 페이지 내 컴포넌트 단위로 들어간 키패드 노출(컨텐츠 길이에 따른 간격 추가 및 스크롤 이동)
        const addPadding = Math.round(window.innerHeight / 2) + 30;
        const $wrap = this.$outputValue.closest('.container-component');
        const headerCalc = $wrap.find('.component-header').length > 0 ? $wrap.find('.component-header').height() : 0;
        const outputPosition = this.$outputValue[0].getBoundingClientRect();
        const nowScroll = this.$outputValue.closest('.page-inner-scroll').scrollTop();

        if (($wrap[0].scrollHeight - (nowScroll + outputPosition.top + outputPosition.height) - headerCalc) <= addPadding) {
            $wrap.css({
                'padding-bottom': `${addPadding}px`,
            })
        }
        this.$el.closest('.section-component').show();

        if ($wrap.find('.component-btn.fixed-bottom').is(':visible')) {
            const zIn = Number($wrap.find('.component-btn.fixed-bottom').css('z-index'));
            this.$el.closest('.component-keypad-trn').css('z-index', zIn+1)
        }
        
        if ((outputPosition.top + outputPosition.height - Math.round(window.innerHeight / 2) >= 0)) {
            const scrollMove = outputPosition.top + outputPosition.height - Math.round(window.innerHeight / 2) + headerCalc + 30;
            
            scrollTo(scrollMove, scrollMotion);
        } else if (outputPosition.top <= 0) {
            scrollTo((outputPosition.top - 30), scrollMotion);
        }
    }

    bottomClose(){ // 페이지 내 컴포넌트 단위로 들어간 키패드 숨김(bottomOpen로 추가된 간격 초기화)
        const $wrap = this.$outputValue.closest('.container-component');
        this.$el.closest('.section-component').hide();
        $wrap.css({
            'padding-bottom': '',
        })
        this.$el.closest('.component-keypad-trn').css('z-index', '');
    }

    destroy() {
        this.detachEvents();
    }

    /**
     * 초기 노출값 설정할 경우
     * @param num    {number|string}  초기 노출값 설정
     * @example 
     * $('.ui-webnumpad').data('ui').setValue(num);
     */
    setValue(num) {
        this.$inputValue.val(num);
        this.outputValue(null, 'plus', true);
    }

    /**
     * 현재 입력된 값 가져오기
     * @param comma    {boolean}  입력된 값에 comma 추가하여 리턴받을 경우 true, 값만 리턴 받을 경우 빈값
     * @example 
     * $('.ui-webnumpad').data('ui').getValue(comma);
     */
    getValue(comma = false){
        if (comma === false) {
            return (this.$inputValue.val());
        } else {
            return (this.setCommaWithDecimalPoint(this.$inputValue.val()));
        }
    }


    /**
     * element, value 등 교체됐을 경우
     * @example 
     * $('.ui-webnumpad').data('ui').refreshNumpad(comma);
     */
    refreshNumpad() {
        this.render();
        if (typeof this.$validationArea !== 'undefined') {
            this.$validationArea.find('.validation-txt-set.show').removeClass('show');
        }
        this.validationCheck();
    }

    dubbleChk(_this){
        $(_this).attr('block', false);
        if($('html').hasClass('ios')){
            if($(_this).attr('block') === true){
                return "ignore";
            }
            $(_this).attr('block', true)

            repeat = setTimeout(function(){
                $(_this).attr('block', false)
                clearTimeout(_super.repeat);
            }, 100);
        }
    }

    // s: FETASK-a11y page webNumpad 접근성 v.1.0.0
    isA11yNumpadAcess(){
        const isA11yCheck = isA11yCheckVersion();

        if(isA11yCheck){
            try {
                isA11yKeyPad();
            } catch (error) {
                throw new Error(error);
            }
        }
    }
    //e: FETASK-a11y page webNumpad 접근성 v.1.0.0 */
}

export default WebNumpad;